module.exports = __webpack_public_path__ + "img/sb_br_cj.6b9aad50.png";